/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_Anwaltspflicht_700px.jpg";
import Typography from "@mui/material/Typography";
import { Link as MuiLink, Paper } from "@mui/material";
import { gaSet } from "../../../services/googleAnalyticsService";

const GuidebookAttorneyDuty = () => {
  const title = "Ratgeber - Anwaltspflicht | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Bei einer Scheidung kommt schnell die Frage auf, ob ein Rechtsanwalt notwendig ist. Wir erklären Ihnen die Anwaltspflicht."
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan slogan={"Einfach erklärt: Anwaltspflicht"} backgroundImagePath={backgroundTeaser} height={300} headingColor={"#333333"} />
        <TextContainer>
          <p>
            Bei einer Scheidung kommt schnell die Frage auf, ob ein Rechtsanwalt notwendig ist. Das Wichtigste vorweg: In Deutschland wird immer mindestens ein
            Anwalt benötigt, um eine Scheidung durchzuführen.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Warum mindestens ein Anwalt notwendig ist
          </Typography>
          <p>
            Um eine Scheidung durchführen zu können, muss in Deutschland ein Rechtsanwalt bzw. Fachanwalt für Familienrecht beauftragt werden. Dies liegt daran,
            dass für die Einreichung des Scheidungsantrags beim Familiengericht die Anwaltspflicht gilt. Eine Scheidung ohne einen Scheidungsanwalt ist daher
            generell nicht möglich.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Unterschied bei einvernehmlicher und streitiger Scheidung
          </Typography>
          <p>
            Wenn Sie sich{" "}
            <MuiLink component={Link} sx={guidebookContentStyle.link} to={"/ratgeber/familienrecht/einvernehmliche-scheidung"}>
              einvernehmlich scheiden lassen
            </MuiLink>{" "}
            möchten, sprich Sie sich mit Ihrem Partner über die Scheidung und auch über alle damit verbundenen{" "}
            <MuiLink component={Link} sx={guidebookContentStyle.link} to={"/ratgeber/familienrecht/wichtige-themen-ueberblick"}>
              Scheidungsfolgesachen
            </MuiLink>{" "}
            geeinigt haben, benötigen Sie nur einen Anwalt. Ein Ehepartner beauftragt den Anwalt, der die Scheidung einreicht und ihn vor Gericht vertritt. Der
            andere Ehepartner muss keinen eigenen Scheidungsanwalt beauftragen, sondern lediglich der Scheidung zustimmen. Die Ehepartner können die Kosten für
            den Anwalt dann untereinander aufteilen. Bei einer einvernehmlichen Scheidung werden so die hohen Kosten für einen zweiten Anwalt vollständig
            eingespart.
          </p>
          <p>
            Bei einer streitigen Scheidung benötigen beide Ehepartner einen Anwalt, damit die unterschiedlichen Interessen beider Ehepartner vor Gericht
            vertreten werden können.
          </p>
          <HighlightBox headline={"Anwaltspflicht bei Scheidungen"}>
            <p>
              In Deutschland ist immer mindestens ein Anwalt nötig, um die Scheidung einreichen zu können. Bei einer einvernehmlichen Scheidung ist ein
              Scheidungsanwalt ausreichend, der dann einen der Ehepartner vertritt. Der andere Ehepartner muss dann lediglich der Scheidung zustimmen.
            </p>
          </HighlightBox>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Ihre Scheidung
          </Typography>
          <p>
            Sie sind sich mit Ihrem Partner einig und möchten mit Ihrer Scheidung beginnen? Sie können ganz einfach alle Angaben für Ihren Scheidungsantrag
            direkt hier eingeben, wir erledigen alles Weitere für Sie.
          </p>
          <DoubleButton buttonText={"zum Scheidungsantrag"} buttonLink={"/servicewelt"} backText={"Zurück zum Ratgeber"} backLink={"/ratgeber/familienrecht"} />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookAttorneyDuty;
